module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_100_250.b849f4ca.png";